var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub_visual_wrap"},[_c('div',{staticClass:"sub_visual_box container"},[_c('div',{staticClass:"page_nav"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Home")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Search Results")])])])]),_c('h2',[_vm._v("Search Results")])])])
}]

export { render, staticRenderFns }